import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { TTripEvent } from 'detailsv2/structure';
import { updateTripEventAction } from 'store/itinerariesItem';
import { tripEventSelector } from 'store/itinerariesItem/chronologicalDetails/selectors';

import { deleteTripEvents } from './ModalContents/DeleteDialog/functions';
import { editTripEvent } from './ModalContents/Edit/functions';

export function useEventOption({ id }: { id: number }) {
  const dispatch = useDispatch();
  // @ts-ignore
  const tripEvent: TTripEvent | undefined = useSelector(tripEventSelector(id));

  const handleEdit = useCallback(async () => {
    if (!tripEvent) {
      return;
    }

    const result = await editTripEvent(tripEvent);

    if (!result) {
      return;
    }

    result.forEach((el) => dispatch(updateTripEventAction(el)));
  }, [dispatch, tripEvent]);
  const handleDelete = useCallback(() => deleteTripEvents([id]), [id]);

  return {
    handleEdit,
    handleDelete,
  };
}
